module.exports = __webpack_public_path__ + "static/media/hydrant.b17ee9b2.svg";